/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListRemoteSessionsResult,
  ListRemoteSessionsResult$inboundSchema,
} from "../components/listremotesessionsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListRemoteSessionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRemoteSessionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRemoteSessionsSecurity = {
  option1?: ListRemoteSessionsSecurityOption1 | undefined;
  option2?: ListRemoteSessionsSecurityOption2 | undefined;
};

export type ListRemoteSessionsRequest = {
  /**
   * Owned agent whose eligible sessions to list; requires user_session_issuer_id.
   */
  principalId?: string | undefined;
  /**
   * Issuer configuration sessions must be eligible for; requires principal_id.
   */
  userSessionIssuerId?: string | undefined;
  /**
   * Exact-match filter on subject URN.
   */
  subjectUrn?: string | undefined;
  /**
   * Filter by remote_session_client id.
   */
  remoteSessionClientId?: string | undefined;
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListRemoteSessionsResponse = {
  result: ListRemoteSessionsResult;
};

/** @internal */
export type ListRemoteSessionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRemoteSessionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListRemoteSessionsSecurityOption1$Outbound,
  ListRemoteSessionsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRemoteSessionsSecurityOption1ToJSON(
  listRemoteSessionsSecurityOption1: ListRemoteSessionsSecurityOption1,
): string {
  return JSON.stringify(
    ListRemoteSessionsSecurityOption1$outboundSchema.parse(
      listRemoteSessionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRemoteSessionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRemoteSessionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListRemoteSessionsSecurityOption2$Outbound,
  ListRemoteSessionsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listRemoteSessionsSecurityOption2ToJSON(
  listRemoteSessionsSecurityOption2: ListRemoteSessionsSecurityOption2,
): string {
  return JSON.stringify(
    ListRemoteSessionsSecurityOption2$outboundSchema.parse(
      listRemoteSessionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRemoteSessionsSecurity$Outbound = {
  Option1?: ListRemoteSessionsSecurityOption1$Outbound | undefined;
  Option2?: ListRemoteSessionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRemoteSessionsSecurity$outboundSchema: z.ZodMiniType<
  ListRemoteSessionsSecurity$Outbound,
  ListRemoteSessionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRemoteSessionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRemoteSessionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRemoteSessionsSecurityToJSON(
  listRemoteSessionsSecurity: ListRemoteSessionsSecurity,
): string {
  return JSON.stringify(
    ListRemoteSessionsSecurity$outboundSchema.parse(listRemoteSessionsSecurity),
  );
}

/** @internal */
export type ListRemoteSessionsRequest$Outbound = {
  principal_id?: string | undefined;
  user_session_issuer_id?: string | undefined;
  subject_urn?: string | undefined;
  remote_session_client_id?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRemoteSessionsRequest$outboundSchema: z.ZodMiniType<
  ListRemoteSessionsRequest$Outbound,
  ListRemoteSessionsRequest
> = z.pipe(
  z.object({
    principalId: z.optional(z.string()),
    userSessionIssuerId: z.optional(z.string()),
    subjectUrn: z.optional(z.string()),
    remoteSessionClientId: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalId: "principal_id",
      userSessionIssuerId: "user_session_issuer_id",
      subjectUrn: "subject_urn",
      remoteSessionClientId: "remote_session_client_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRemoteSessionsRequestToJSON(
  listRemoteSessionsRequest: ListRemoteSessionsRequest,
): string {
  return JSON.stringify(
    ListRemoteSessionsRequest$outboundSchema.parse(listRemoteSessionsRequest),
  );
}

/** @internal */
export const ListRemoteSessionsResponse$inboundSchema: z.ZodMiniType<
  ListRemoteSessionsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListRemoteSessionsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listRemoteSessionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListRemoteSessionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRemoteSessionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRemoteSessionsResponse' from JSON`,
  );
}
